import React, { useState } from 'react';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './verifyEmailForm.css';
import logo from '../images/Logo.png';

const OlvidasteContrasenia = ({ handleTabChange }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const auth = getAuth();
  const navigate = useNavigate();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordReset = async () => {
    setLoading(true);
    setMessage('');
    setError('');

    try {
      // Generar enlace personalizado para restablecimiento
      const resetUrl = `${window.location.origin}/reset-password?email=${encodeURIComponent(email)}`;
      await sendPasswordResetEmail(auth, email, { url: resetUrl });
      setMessage('Correo de restablecimiento enviado. Revisa tu bandeja de entrada.');
    } catch (err) {
      setError('Error al enviar el correo. Verifica el email ingresado.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-form-container2">
      <form className="form-container-log2" onSubmit={(e) => e.preventDefault()}>
        <img src={logo} alt="logo2" className="logo" />
        <br />
        <p className="text-loggin2">¿Olvidaste tu contraseña?</p>
        <div className="verify-email-container2">
          <p>Ingresa tu correo electrónico para restablecer tu contraseña.</p>
          <div className="floating-label2">
            <input
              id="email"
              type="email"
              value={email}
              onChange={handleEmailChange}
              required
              placeholder=""
            />
            <label htmlFor="email">Email</label>
          </div>
          <button
            type="button"
            className="botonReenviar"
            onClick={handlePasswordReset}
            disabled={loading || !email}
          >
            {loading ? 'Enviando...' : 'Enviar correo para restablecer contraseña'}
          </button>
          {message && <p className="success-message">{message}</p>}
          {error && <p className="error-message">{error}</p>}
          <div className="info-message">
            ¿Ya tienes una cuenta?
            <span className="clickable" onClick={() => handleTabChange('login')}>
              Inicia sesión aquí.
            </span>
          </div>
        </div>
      </form>
    </div>
  );
};

export default OlvidasteContrasenia;
